import React from 'react'
import BrandFeatures from '@/component/Primitive/Brand/component/BrandFeatures'

const BrandFeaturesWidget = () => <BrandFeatures />

export default BrandFeaturesWidget
